"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSelect = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CardSelect = _ref => {
  let {
    backgroundColor,
    image,
    label,
    selected,
    colorSelected,
    size,
    onClick
  } = _ref;
  const useStyles = (0, _styles.makeStyles)(theme => ({
    rootSmall: {
      boxShadow: 'none',
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      width: 64,
      height: 72
    },
    rootLarge: {
      boxShadow: 'none',
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      width: 80,
      height: 86
    },
    media: {
      backgroundColor,
      border: '1px solid rgba(0, 0, 0, 0.23)',
      position: 'relative',
      '&:hover div': {
        backgroundColor: 'rgba(0, 0, 0, 0.03)'
      },
      '&:focus div': {
        backgroundColor: 'transparent'
      }
    },
    small: {
      borderRadius: `${theme.shape.borderRadius}px`,
      height: '48px',
      width: '48px'
    },
    large: {
      borderRadius: `${theme.shape.borderRadius}px`,
      height: '64px',
      width: '64px'
    },
    imageOverlay: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      borderRadius: theme.shape.borderRadius
    },
    checkOverlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: colorSelected === 'white' ? theme.palette.background.paper : '#000000'
    },
    labelWrapper: {
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      marginTop: 2,
      fontSize: 12,
      minHeight: 20,
      '&:last-child': {
        paddingBottom: '0'
      }
    },
    imgSize: {
      width: '99%',
      position: 'relative'
    }
  }));
  const classes = useStyles();
  const renderHover = () => {
    return null || !image && /*#__PURE__*/_react.default.createElement("div", {
      className: `${classes.imageOverlay} ${classes[size]}`
    });
  };
  const renderImage = () => {
    return null || image && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: image,
      alt: "-",
      className: `${classes[size]} ${classes.imgSize}`
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: `${classes.imageOverlay} ${classes[size]}`
    }));
  };
  const [inHover, setHover] = _react.default.useState(false);
  const renderCheck = () => {
    return selected && /*#__PURE__*/_react.default.createElement("span", {
      className: classes.checkOverlay,
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false)
    }, inHover ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_icons.Close, null)) : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_icons.Check, null)));
  };
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: size === 'small' ? classes.rootSmall : classes.rootLarge,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    className: `${classes.media} ${classes[size]}`
  }, renderHover(), renderImage(), renderCheck()), /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.labelWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption"
  }, label)));
};
exports.CardSelect = CardSelect;
CardSelect.propTypes = {
  image: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  label: _propTypes.default.string,
  selected: _propTypes.default.bool,
  colorSelected: _propTypes.default.oneOf(['black', 'white']),
  size: _propTypes.default.oneOf(['small', 'large']),
  onClick: _propTypes.default.func
};
CardSelect.defaultProps = {
  backgroundColor: '#ffffff',
  image: null,
  label: '',
  selected: false,
  colorSelected: 'black',
  size: 'small',
  onClick: () => null
};